module.exports = __webpack_public_path__ + "static/img/6.ee25a1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/6.png
// module id = iHIX
// module chunks = 0